import React from 'react';
// import { usePhotos } from '../../hooks/UsePhotos';
import { IMAGES } from '../../../config/images';

const RecommendationsSection = () => {



  const recommendations = [
    {
      id: 16,
      name: "Лофт проект Этажи",
      desc: "Культурный центр в здании бывшего хлебозавода: галереи, магазины, кафе, терраса на крыше с видом на город",
      photo: IMAGES.recommendPhoto1,
      type: 'location'
    },
    {
      id: 15,
      name: "Сад «Сен-Жермен»",
      desc: "Культовое андеграундное место, где в конце 1970-х годов собиралась творческая элита города",
      photo: IMAGES.recommendPhoto2,
      type: 'location'
    },
    {
      id: 5,
      name: "Маршурт по Растрелли",
      desc: "Объединяет ключевые шедевры елизаветинского барокко, демонстрируя масштаб и роскошь имперской архитектуры XVIII века.",
      photo: "/elements/recommendPhoto33.png",
      type: 'route'
    },
    {
      id: 14,
      name: "Севкабель порт",
      desc: "Общественное пространство на берегу Финского залива, которое предлагает разнообразные мероприятия, кафе и уникальные виды на залив",
      photo: IMAGES.recommendPhoto4,
      type: 'location'
    }
  ];

  const getLink = (item) => {
    if (item.type === 'location') {
      return `/locations/${item.id}`;
    } else if (item.type === 'route') {
      return `/routes/${item.id}`;
    }
    return `#`;
  };

  return (
    <section id="recommendations" className="flex-column">
      <p id="recommendationsHeader">РЕКОМЕНДАЦИИ</p>

      <div id="recommendationCardsWrapper" className="flex-row">
        {recommendations.map((item) => (
          <a key={item.id} href={getLink(item)}>
            <div className="recommendationCard flex-column">
              <img className="recommendationCardPhoto" src={item.photo} alt={item.name} />
              <p className="recommendationCardName">{item.name}</p>
              <p className="recommendationCardDesc">{item.desc}</p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default RecommendationsSection;